import type { UseFormRegister } from 'react-hook-form';
import { getAcceptedFileTypes } from '../../../../utils';
import InputError from '../Error';
import styles from './FileInputField.module.css';

const FileInputField = ({
  label,
  id,
  error,
  value,
  customClassName,
  name,
  accept = getAcceptedFileTypes(),
  register,
}: {
  label?: string | number;
  name: string;
  id?: string;
  value?: string;
  error?: string;
  customClassName?: string;
  accept?: string;
  register: UseFormRegister<any>;
}) => (
  <div className={`${customClassName}`}>
    <label className={'leading-7 block text-sm font-medium text-neutralColor-medium'} htmlFor={id || name}>
      {label}
    </label>
    <div className='flex w-full'>
      <label htmlFor={id || name} className='flex-1 w-2/3'>
        <span className={`${error ? styles['form-input-error'] : styles['form-input-normal']}`}>
          <span className='py-2 px-3 truncate'>{value}</span>
        </span>
      </label>
      <div className={styles['upload-button']}>
        <span>Choose File</span>
        <input
          className={'absolute w-full opacity-0 cursor-pointer'}
          id={id || name}
          type='file'
          accept={accept}
          autoComplete={id || name}
          {...register(name)}
        />
      </div>
    </div>
    {error && <InputError>{error}</InputError>}
  </div>
);

export default FileInputField;
